module.exports = __webpack_public_path__ + "static/media/queues.657c4bb1.svg";